import React from 'react'
import { toJS } from 'mobx'
import './index.scss'

//api
import { api } from '../../../../../functions/api'

//custom components
import CustomInput from '../../../../../components/basic/input'
import CustomButton from '../../../../../components/basic/CustomButton'

//material-ui
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import { MenuItem, MuiThemeProvider, createMuiTheme } from '@material-ui/core'

//other libraries
import { inject, observer } from 'mobx-react'
import SelectSearch from '../../../../../components/basic/SelectSearch/SelectSearch'

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      disabled: {
        '&:before': {
          borderBottomStyle: 'solid !important',
        },
      },
    },
  },
})


@inject('translate')
@inject('internal')
@observer
export default class NewEditBranch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      loadingBtn: false,
      message: '',
      openSnackbar: false,
      user: -1,
      responsible: [],
      users: [],
    }
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.open === false && this.props.open === true) {
          this.resolveBranch()
      }
  }
  
  resolveBranch = () => {
    this.setState({ responsible: [] }, () => {
      if (this.props.idBranch) {
        let branchces = toJS(this.props.internal.dataForTable.data)
        let editBranch = {}
        for (let i = 0; i < branchces.length; i++) {
          if (branchces[i].id === this.props.idBranch) {
            editBranch = branchces[i]
            break
          }
        }
        if (editBranch.hasOwnProperty('responsible')) {
          this.setState({ responsible: editBranch.responsible.map(user => ({value: user.id, label: user.username})) })
        }
      }
    })
  }
  
  componentDidMount() {
    this.loadClientUsers()
  }
  
  loadClientUsers = async () => {
    let idClient = toJS(this.props.routerData.match.params.idClient)
    let load_data = await api({
      method: 'get',
      url: 'clients/' + idClient + '/members/all',
      authorization: this.props.internal.user.access_token,
    })
    
    if (load_data.success === true) {
      // for(let i=0; i<load_data.data.data.length; i++) {
      //     let user = {
      //         id: load_data.data.data[i].id,
      //         name: load_data.data.data[i].username
      //     }
      //     this.users.push(user)
      // }
      const availableMembers = load_data.data.data.members.map(user => ({ value: user.id, label: user.username }))
      this.setState({ users: availableMembers })
    }
    this.setState({ loading: false })
  }
  
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    })
  }
  
  handleCreateOrEditUser = async () => {
    
    this.setState({ loadingBtn: true })
    let name = this.name.state.value
    // let contact_person = this.contact_person.state.value;
    let street_name = this.street_name.state.value
    let street_no = this.street_no.state.value
    let zip = this.zip.state.value
    let city = this.city.state.value
    let country = this.country.state.value
    
    
    if (name === '' || street_name === '' || street_no === '' || zip === '' || city === '' || country === '') {
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_FILL_ALL_INPUTS, true)
      
    } else {
      
      let idClient = toJS(this.props.routerData.match.params.idClient)
      
      let url = 'clients/' + idClient + '/branches'
      
      let method = 'post'
      if (this.props.idBranch) {
        url += '/' + this.props.idBranch
        method = 'patch'
      }
      
      
      let params = {
        name: name,
        street_name: street_name,
        street_no: street_no,
        zip: zip,
        city: city,
        country: country,
      }
      
      params['responsible_id'] = this.state.responsible.map(item => item.value)
      
      let create_data = await api({
        method: method,
        url: url,
        authorization: this.props.internal.user.access_token,
        // params: {
        //     name: name,
        //     contact_person: contact_person,
        //     street_name: street_name,
        //     street_no: street_no,
        //     zip: zip,
        //     city: city,
        //     country: country,
        // }
        params: params,
      })
      
      if (create_data.success === true) {
        this.setState({ message: create_data.data.message, openSnackbar: true })
        this.props.showSnackbar(create_data.data.message, true)
        if (this.props.idBranch) {
          let dataEdit = {
            edit: false,
            id: null,
          }
          this.props.internal.setActionEdit(dataEdit)
        }
      } else if (create_data.success === false && create_data.status === 201) {
        this.props.showSnackbar(create_data.data.message, true, true)
      } else {
        let resultError = ''
        for (let error in create_data.data.data.errors) {
          resultError += create_data.data.data.errors[error] + ' '
        }
        //this.setState({message: resultError, openSnackbar: true})
        //this.props.showSnackbar(this.state.message, this.state.openSnackbar, false)
        this.props.internal.setSnackbar(resultError, true)
      }
    }
    
    this.setState({ loadingBtn: false })
    
  }
  
  render() {
    let editBranch = {}
    if (this.props.idBranch) {
      let branchces = toJS(this.props.internal.dataForTable.data)
      for (let i = 0; i < branchces.length; i++) {
        if (branchces[i].id === this.props.idBranch) {
          editBranch = branchces[i]
          break
        }
      }
    }
    
    return (
      <MuiThemeProvider theme={theme}>
        <Dialog
          open={this.props.open}
          onClose={this.props.onClose}
          aria-labelledby="form-dialog-title"
          className={'create-branch'}
        >
          <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
          <DialogContent>
            <Grid container spacing={24}>
              {this.props.idBranch &&
              <Grid item xs={12} sm={6} className={'new-branch-filed'}>
                <CustomInput
                  ref={ref => this.name = ref}
                  text={this.props.translate.i18n.MODULES.CLIENTS.BRANCH_ID}
                  value={this.props.idBranch ? editBranch.branch_id : ''}
                  id={'title'}
                  className={'mr-10 w-100 '}
                  disabled
                />
              </Grid>
              }
              <Grid item xs={12} sm={6} className={'new-branch-filed'}>
                <CustomInput
                  ref={ref => this.name = ref}
                  text={this.props.translate.i18n.MODULES.CLIENTS.TITLE}
                  value={this.props.idBranch ? editBranch.name : ''}
                  id={'title'}
                  className={'mr-10 w-100 '}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6} className={'new-branch-filed'}>
                {/*    <TextField*/}
                {/*        id="standard-select-currency-native"*/}
                {/*        select*/}
                {/*        label={this.props.translate.i18n.GLOBAL.CONTACT.CONTACT_PERSON}*/}
                {/*        value={this.state.responsible}*/}
                {/*        // defaultValue={this.state.privilegies}*/}
                {/*        onChange={this.handleChange('responsible')}*/}
                {/*        className={"mr-10 w-100  users-select"}*/}
                {/*        SelectProps={{*/}
                {/*            MenuProps: {*/}
                {/*            },*/}
                {/*            multiple: true*/}
                {/*        }}*/}
                {/*        margin="normal"*/}
                {/*    >*/}
                {/*    <MenuItem value={-1}><em>Žiadna</em></MenuItem>*/}
                {/*    {this.users.map(option => (*/}
                {/*        */}
                {/*        <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>*/}
                {/*    ))}*/}
                {/*</TextField>*/}
                
                <SelectSearch
                  options={this.state.users}
                  // key={`param-${i}`}
                  onChange={val => this.setState({ responsible: val })}
                  value={this.state.responsible}
                  isMulti={true}
                  className={'select-search'}
                  label={this.props.translate.i18n.GLOBAL.CONTACT.CONTACT_PERSON}
                  // menuIsOpen
                  // onMenuOpen={this.handleScrollDown}
                />
              </Grid>
              <Grid item xs={12} sm={6} className={'new-branch-filed'}>
                <CustomInput
                  ref={ref => this.street_name = ref}
                  text={this.props.translate.i18n.GLOBAL.ADRESS.ADRESS}
                  value={this.props.idBranch ? editBranch.street_name : ''}
                  id={'street_name'}
                  className={'w-100 '}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6} className={'new-branch-filed'}>
                <CustomInput
                  ref={ref => this.street_no = ref}
                  text={this.props.translate.i18n.GLOBAL.ADRESS.STREET_NO}
                  value={this.props.idBranch ? editBranch.street_no : ''}
                  id={'street_no'}
                  className={'w-100 '}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6} className={'new-branch-filed'}>
                <CustomInput
                  ref={ref => this.zip = ref}
                  text={this.props.translate.i18n.GLOBAL.ADRESS.ZIP}
                  value={this.props.idBranch ? editBranch.zip : ''}
                  id={'zip'}
                  className={'w-100 '}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6} className={'new-branch-filed'}>
                <CustomInput
                  ref={ref => this.city = ref}
                  text={this.props.translate.i18n.GLOBAL.ADRESS.CITY}
                  value={this.props.idBranch ? editBranch.city : ''}
                  id={'city'}
                  className={'w-100 '}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6} className={'new-branch-filed'}>
                <CustomInput
                  ref={ref => this.country = ref}
                  text={this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}
                  value={this.props.idBranch ? editBranch.country : ''}
                  id={'country'}
                  className={'w-100 '}
                  required
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose} className={'gray-text'}>
              {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
            </Button>
            {/* <Button onClick={this.handleCreateOrEditUser} className={'orange-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button> */}
            <CustomButton
              justText
              progressBar={this.state.loadingBtn}
              onClick={this.handleCreateOrEditUser}
              mystyle={'btn-white-bg width-80'}
              title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
            />
          </DialogActions>
        
        </Dialog>
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/branches/add/index.js